export default {
  path: '/store-center',
  meta: {
    title: '店铺首页',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/store-center`),
}



// WEBPACK FOOTER //
// ./src/views/StoreCenter/router.js